import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import _extends from "@babel/runtime-corejs2/helpers/extends";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import * as React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { getDataDependency, getDisplayName } from 'gandi.react-helpers';
import useTranslator from './useTranslator';
import createTranslatorProps from './createTranslatorProps';

// $FlowIgnore[unclear-type]

/**
 * Translator HOC: to use with class components.
 *
 * It works with function components too, but better to use `useTranslator`
 * there instead.
 */
export default function withTranslator(options) {
  return function (WrappedComponent) {
    var namespace = options === null || options === void 0 ? void 0 : options.propsNamespace;
    var WithTranslator = function WithTranslator(props) {
      var translatorProps = useTranslator();
      var namespacedProps = namespace ? _defineProperty({}, namespace, translatorProps) : translatorProps;
      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, namespacedProps));
    };
    WithTranslator.displayName = "WithTranslator(".concat(getDisplayName(WrappedComponent), ")");
    var HoistedComponent = hoistNonReactStatic(WithTranslator, WrappedComponent);
    var wrapHandler = function wrapHandler(handlerName) {
      // Call child preFetch if any
      var wrappedHandler = getDataDependency(WrappedComponent, handlerName);
      if (!wrappedHandler) {
        return null;
      }

      // $FlowFixMe[incompatible-use]
      HoistedComponent[handlerName] = function (props) {
        var translator = props.res.locals.translator;
        for (var _len = arguments.length, extra = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          extra[_key - 1] = arguments[_key];
        }
        if (!translator) {
          // eslint-disable-next-line no-console
          console.error("Missing translator in ".concat(handlerName));

          // Not ready yet, abort for this handler.
          return wrappedHandler.apply(void 0, [props].concat(extra));
        }
        var translatorProps = createTranslatorProps(translator);
        var wrapperComponentProps = _objectSpread(_objectSpread({}, props), namespace ? _defineProperty({}, namespace, translatorProps) : translatorProps);
        return wrappedHandler.apply(void 0, [wrapperComponentProps].concat(extra));
      };
      return HoistedComponent;
    };
    wrapHandler('preFetch');
    wrapHandler('handleRedirect');
    wrapHandler('handleForm');
    return HoistedComponent;
  };
}